import Swal from 'sweetalert2';
import { Chat } from '@/mocks/app/mockChatData';
import { ChatStore } from '@/stores/app/chatStore';
import { grupoEstaSilenciado } from '@/stores/app/chatUtils';
import { DuracaoSilencio } from '@/services/grupos/grupos.service';
import { IdGrupo } from '@/services/common-types';
import { branding } from '@/config/branding';

const brandColor = branding.colors.light.primary;

/** Silenciado → reativa direto. Não silenciado → pergunta por quanto tempo. */
export async function PromptToAlternarSilencioGrupo(chat: Chat, chatStore: ChatStore) {
    if (grupoEstaSilenciado(chat)) {
        return chatStore.reativarNotificacoesGrupo(chat.id as IdGrupo);
    }

    const { value: duracao } = await Swal.fire<DuracaoSilencio>({
        title: 'Silenciar grupo',
        text: 'Você não vai receber notificações nem som das mensagens deste grupo por:',
        input: 'radio',
        inputOptions: { '8h': '8 horas', '1semana': '1 semana', 'sempre': 'Sempre' },
        inputValue: '8h',
        showCancelButton: true,
        confirmButtonText: 'Silenciar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: brandColor,
    });
    if (!duracao) return; // cancelado

    return chatStore.silenciarGrupo(chat.id as IdGrupo, duracao);
}
